import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo, pageSeo } from "../lib/seo";

/**
 * Sets each page's title, description and indexing rules as the route
 * changes. Rendered before the routes, so a page that describes itself
 * with useSeo (a shop, search results) has the last word.
 */
export default function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeo(pageSeo(pathname));
  }, [pathname]);

  return null;
}
